import { ErrorPage } from "../../features/errors";

export function NotFound() {
  return <ErrorPage status={404} />;
}
